import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import CBAErrorHandler from "../../error/error.handler";
import { environment } from "../../../environments/environment";

import * as $ from "jquery";
import * as _ from "underscore";

import { SpService } from "./sp.service";
import { MagicLinkService } from "./magic_link.service";

@Component({
  selector: "app-sales-presenters",
  templateUrl: "./sales-presenters.component.html",
  providers: [SpService, MagicLinkService]
})
export class SalesPresentersComponent implements OnInit {
  public magicLink = null;
  private isLoading = true;
  private listDetail = null;
  private isCustomerList = false;
  private region = null;
  private season = null;
  private country = null;
  private salesPresenters = null;
  private adults = [];
  private kids = [];
  private originals = [];
  private activeSp = null;
  public ENV = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spService: SpService,
    private mlService: MagicLinkService
  ) {
    this.route.params.subscribe((params: Params) => {
      let magicLink = params["shortId"];
      if (magicLink) {
        this.magicLink = magicLink;
        this.loadSalesPresenters();
      }
    });
  }

  ngOnInit() {
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop() + 180;

        // Assign active class to nav links while scolling
        $(".sp-section").each(function (i) {
          if ($(this).position().top <= scrollDistance) {
            $(".navmenu ul li a.active").removeClass("active");
            $(".navmenu ul li a").eq(i).addClass("active");
          }
        });
      })
      .scroll();
  }

  goBack() {
    window.history.back();
  }

  clickNavMenu(name) {
    var mobileWindow = $(window).width() <= 768;
    var smallWindow = $(window).width() <= 1200;
    if (mobileWindow) {
      $(".navbar-toggle").click();
    }
    if (smallWindow) {
      $("html,body").animate(
        {
          scrollTop: $("#" + name).offset().top - 225
        },
        1000
      );
    }
    if (!smallWindow) {
      $("html,body").animate(
        {
          scrollTop: $("#" + name).offset().top - 180
        },
        1000
      );
    }
    return false;
  }
  loadSalesPresenters() {
    this.isLoading = true;

    this.mlService
      .getDetail(this.magicLink)
      .then(res => {
        if (res && res["customer_list"]) {
          this.isCustomerList = true;
          this.listDetail = res["customer_list"];
        }
        if (res && res["export_list"]) {
          this.isCustomerList = false;
          this.listDetail = res["export_list"];
        }
        return true;
      })
      .then(res => {
        this.region = this.listDetail.region;
        this.season = this.getSeason(this.listDetail.season);
        this.country = this.listDetail.country;
        return this.spService.getSalesPresenters(
          this.season,
          this.region,
          this.country
        );
      })
      .then(resSalesPresenter => {
        this.isLoading = false;
        this.salesPresenters = resSalesPresenter;
        this.salesPresenters = this.formatsp(this.salesPresenters);

        if (this.salesPresenters && this.salesPresenters[0]) {
          this.activeSp = this.salesPresenters[0]["name"];
        }
      })
      .catch(e => {
        this.handleError(e);
        this.isLoading = false;
      });
  }
  formatsp(salesPresenters) {
    let tmpData = [];
    for (let sp of salesPresenters) {
      if (!_.isEmpty(sp.items)) {
        tmpData.push(sp);
      }
    }
    return tmpData;
  }
  handleError(e) {
    if (e._body) {
      try {
        let serverResponse = JSON.parse(e._body);
        e.statusText = serverResponse["message"];
      } catch (e) {}
    }

    if (e.status === 403) {
      this.router.navigateByUrl("/error/not-authorised");
    } else if (e.status === 404) {
      this.router.navigateByUrl("/error/not-found");
    } else {
      let errorHandler = new CBAErrorHandler();
      //errorHandler.notifyRaven(e);
      this.router.navigateByUrl("/error/internal-error");
    }
  }
  getSeason(season) {
    season = season || "";
    let tmpSeason = season.split("-");
    if (tmpSeason[0].length === 6) {
      return tmpSeason[0].toUpperCase();
    }
    let seasonStr = tmpSeason[0].substr(0, 2);
    let yearStr = tmpSeason[0].substr(2, 4);
    return (seasonStr + "20" + yearStr).toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/products/sales-presenters/sales-presenters.component.ts